/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable max-lines */
/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
import app from 'Cloud/Application/app';
import { downloadAsJpeg } from 'Cloud/Application/DownloadAsJpeg';
import { isFeature } from 'Cloud/Application/FeaturesEs6';
import { ReactComponent as AddFolderIcon } from 'img/icons/addFolder.svg';
import { ReactComponent as DocumentIcon } from 'img/icons/createDoc.svg';
import { ReactComponent as UploadFolderIcon } from 'img/icons/uploadFolderMenu.svg';
import { ReactComponent as UploadIcon } from 'img/icons/uploads.svg';
import { ReactComponent as SocialsShareIcon } from 'mrg-icons/src/mailru/actions/share.svg';
import { ReactComponent as SocialsShareMmIcon } from 'mrg-icons/src/mailru/social/moimir.svg';
import { ReactComponent as SocialsShareOkIcon } from 'mrg-icons/src/mailru/social/ok.svg';
import { ReactComponent as SocialsShareTwIcon } from 'mrg-icons/src/mailru/social/twitter.svg';
import { ReactComponent as SocialsShareVkIcon } from 'mrg-icons/src/mailru/social/vk.svg';
import { path, pathOr } from 'ramda';
import React from 'react';
import {
    canCloneWeblink,
    getDownloadItemSize,
    isDomainFolder,
    isFileForOpenInEditor,
    isReadOnly,
    openEditor,
    publishSocial,
} from 'reactApp/appHelpers/appHelpers';
import { IS_MY_TEAM, IS_ONPREMISE, IS_OWN_PUBLIC, IS_PUBLIC_ALBUM } from 'reactApp/appHelpers/configHelpers';
import { publishHelper, unPublishHelper } from 'reactApp/appHelpers/publishHelper';
import { toolbarActions } from 'reactApp/appHelpers/toolbarActions';
import { MAX_EMAIL_URL_LENGTH, ROOT_FOLDER_ID } from 'reactApp/constants/magicIdentificators';
import { isAddToAlbumsEnabled, isCreatePublicAlbumsEnabled } from 'reactApp/modules/albums/albums.selector';
import { isAlbum } from 'reactApp/modules/albums/albums.types';
import { getCreateDescriptions } from 'reactApp/modules/editor/editor.selectors';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { isMediaFolderAndGalleryEnabled } from 'reactApp/modules/file/utils';
import { filesFilterAll, filesFilterOne } from 'reactApp/modules/filesFilter/filesFilter.module';
import { getCurrentFilter } from 'reactApp/modules/filesFilter/filesFilter.selectors';
import { addToFavorites, removeFromFavorites } from 'reactApp/modules/modifying/modifying.actions';
import { getGoToAndScrollUrl } from 'reactApp/modules/modifying/modifying.helpers';
import { isPublicUploadEnabled } from 'reactApp/modules/public/public.selectors';
import { settingsController } from 'reactApp/modules/settings/settings.controller';
import { EViewMode } from 'reactApp/modules/settings/settings.types';
import { getSort } from 'reactApp/modules/sort/sort.selectors';
import { ESortOder, ESortTypes } from 'reactApp/modules/sort/sort.types';
import { getStorageConfig } from 'reactApp/modules/storage/storage.config';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import {
    getFolderAuthors,
    getStorageCurrentFolder,
    isMountedFolder,
    isMountedOrSharedFolder,
    isSharedFolder,
} from 'reactApp/modules/storage/storage.selectors';
import { CloudItem, EStorageType } from 'reactApp/modules/storage/storage.types';
import { isUploadFolderAllowed } from 'reactApp/modules/upload/upload.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { openUserQuotaItemView } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.actions';
import { store } from 'reactApp/store';
import { DropdownTheme } from 'reactApp/ui/DropdownList/DropdownList';
import { EColor, FavoriteIcon } from 'reactApp/ui/FavoriteIcon/FavoriteIcon';
import {
    AddCircle,
    AddToAlbum,
    CalendarIcon,
    CompareIcon,
    CopyIcon,
    DownloadIcon,
    ExternalLinkIcon,
    HistoryIcon,
    LinkIcon,
    MailIcon,
    MoveIcon,
    RenameIcon,
    ShareAlbumIcon,
    ShareIcon,
    SortIcon,
    TextIcon,
    TrashbinIcon,
    UploadIcon as SaveToCloudIcon,
    UserIcon,
    UsersIcon,
    ViewCardsIcon,
    ViewGalleryIcon,
    ViewListIcon,
} from 'reactApp/ui/VKUIIcons';
import { noop, noopVoid } from 'reactApp/utils/helpers';
import { getTrimmedText } from 'reactApp/utils/textHelpers';

import { ContextMenuItem } from './ContextMenu';
import { getPathToNewTab } from './ContextMenu.helpers';

const isMobile = EnvironmentSelectors.isMobile() || EnvironmentSelectors.isIpadOs();
const sendViaMailEnabled = isFeature('attaches-enabled');

export interface Item {
    id: string;
    href?: string;
    home?: string;
    weblink: undefined | string;
    isFolder: boolean;
    isInFavorites: boolean;
    sizeTitle: string;
    ext2: string;
    [key: string]: unknown;
    parentFolder?: string;
    parent?: string;
    ext?: string;
}

const CONTEXT_MENU = 'context-menu';

export const contextMenuItems: { [key: string]: ContextMenuItem } = {
    create: {
        id: 'create',
        text: 'Создать',
        divider: true,
        icon: <AddCircle data-qa-id="create" />,
        mod: 'new',
    },
    createFolder: {
        id: 'createFolder',
        text: 'Папку',
        icon: <AddFolderIcon data-qa-id="createFolder" />,
        onClick: (): void => toolbarActions.create('folder', 'ctx'),
        mod: 'new',
        hotkey: 'Shift+F',
    },
    createDoc: {
        id: 'createDoc',
        text: 'Документ',
        icon: <DocumentIcon data-qa-id="createDoc" color="#005FF9" />,
        onClick: (): void => toolbarActions.create('docx', 'ctx'),
        mod: 'new',
        hotkey: 'Shift+T',
    },
    createCell: {
        id: 'createCell',
        text: 'Таблицу',
        icon: <DocumentIcon data-qa-id="createCell" color="#0DC268" />,
        onClick: (): void => toolbarActions.create('xlsx', 'ctx'),
        mod: 'new',
        hotkey: 'Shift+S',
    },
    createPpt: {
        id: 'createPpt',
        text: 'Презентацию',
        icon: <DocumentIcon data-qa-id="createPpt" color="#FF9E00" />,
        onClick: (): void => toolbarActions.create('pptx', 'ctx'),
        mod: 'new',
        hotkey: 'Shift+P',
    },
    view: {
        id: 'view',
        text: 'Вид',
        icon: <ViewCardsIcon data-qa-id="view" />,
    },
    viewThumbs: {
        text: 'Таблицей',
        id: 'viewThumbs',
        icon: <ViewCardsIcon data-qa-id="viewThumbs" />,
        withStatus: true,
        onClick: () => toolbarActions.view('thumbs'),
    },
    viewList: {
        text: 'Списком',
        id: 'viewList',
        icon: <ViewListIcon data-qa-id="viewList" />,
        withStatus: true,
        onClick: () => toolbarActions.view('list'),
    },
    viewGallery: {
        text: 'Галереей',
        id: 'viewGallery',
        icon: <ViewGalleryIcon />,
        withStatus: true,
        onClick: () => toolbarActions.view('gallery'),
    },
    sort: {
        id: 'sort',
        text: 'Сортировка',
        icon: <SortIcon data-qa-id="sort" />,
    },
    sortName: {
        text: 'По алфавиту',
        id: 'sortName',
        withStatus: true,
        icon: <TextIcon data-qa-id="sortName" />,
        onClick: (asc: boolean) => toolbarActions.sort(`name-${asc ? ESortOder.asc : ESortOder.desc}`),
    },
    sortSize: {
        text: 'По размеру',
        id: 'sortSize',
        withStatus: true,
        icon: <CompareIcon data-qa-id="sortSize" />,
        onClick: (asc: boolean) => toolbarActions.sort(`size-${asc ? ESortOder.asc : ESortOder.desc}`),
    },
    sortDate: {
        text: 'По дате',
        id: 'sortDate',
        withStatus: true,
        icon: <CalendarIcon data-qa-id="sortDate" />,
        onClick: (asc: boolean) => toolbarActions.sort(`mtime-${asc ? ESortOder.asc : ESortOder.desc}`),
    },
    socialsShare: {
        id: 'socialsShare',
        text: 'Поделиться',
        icon: <SocialsShareIcon data-qa-id="socialsShare" />,
    },
    socialsShareVk: {
        text: 'VK',
        id: 'socialsShareVk',
        icon: <SocialsShareVkIcon data-qa-id="socialsShareVk" />,
    },
    socialsShareOk: {
        text: 'Одноклассники',
        id: 'socialsShareOk',
        icon: <SocialsShareOkIcon data-qa-id="socialsShareOk" />,
    },
    socialsShareTw: {
        text: 'Twitter',
        id: 'socialsShareTw',
        icon: <SocialsShareTwIcon data-qa-id="socialsShareTw" />,
    },
    socialsShareMm: {
        text: 'Мой мир',
        id: 'socialsShareMm',
        icon: <SocialsShareMmIcon data-qa-id="socialsShareMm" />,
    },
    newTab: {
        text: 'Открыть в новой вкладке',
        id: 'newTab',
        icon: <ExternalLinkIcon data-qa-id="newTab" />,
    },
    parentFolder: {
        text: 'Показать в папке',
        id: 'parentFolder',
        divider: true,
        icon: <ExternalLinkIcon data-qa-id="parentFolder" />,
    },
    publish: {
        text: 'Открыть доступ по ссылке',
        id: 'publish',
        icon: <LinkIcon data-qa-id="publish" />,
    },
    publishAlbum: {
        text: 'Поделиться',
        id: 'publishAlbum',
        icon: <ShareAlbumIcon data-qa-id="publish-album" />,
        onClick: toolbarActions.createAndPublishAlbum,
    },
    addToAlbum: {
        text: 'Добавить в альбом',
        id: 'add-to-album',
        icon: <AddToAlbum data-qa-id="add-to-album" />,
        onClick: toolbarActions.addToAlbum,
    },
    publishGetLink: {
        text: 'Настроить доступ по ссылке',
        id: 'publishGetLink',
        icon: <LinkIcon data-qa-id="publishGetLink" />,
    },
    unPublish: {
        text: 'Закрыть доступ по ссылке',
        id: 'unPublish',
        icon: <LinkIcon data-qa-id="unPublish" />,
    },
    share: {
        text: 'Пригласить пользователей',
        id: 'share',
        icon: <ShareIcon data-qa-id="share" />,
    },
    manageAccess: {
        text: 'Управление доступом',
        id: 'manageAccess',
        icon: <ShareIcon data-qa-id="manageAccess" />,
    },
    mountFolder: {
        text: 'Подключить к Облаку',
        id: 'mountFolder',
        icon: <UsersIcon data-qa-id="mountFolder" />,
        onClick: toolbarActions.mount,
    },
    sendViaMail: {
        text: 'Отправить по почте',
        id: 'sendViaMail',
        icon: <MailIcon data-qa-id="sendViaMail" />,
        onClick: toolbarActions.forward,
    },
    saveToCloud: {
        text: 'Сохранить в Облако',
        id: 'saveToCloud',
        icon: <SaveToCloudIcon data-qa-id="saveToCloud" />,
        onClick: (id) => toolbarActions.clone({ id, source: CONTEXT_MENU }),
    },
    authors: {
        text: 'Авторы',
        id: 'authors',
        icon: <UsersIcon data-qa-id="authors" />,
    },
    showAuthorFiles: {
        text: 'Все файлы этого автора',
        id: 'authorFiles',
        icon: <UsersIcon data-qa-id="authorFiles" />,
    },
    showAllAuthorFiles: {
        text: 'Файлы от всех авторов',
        id: 'allAuthorFiles',
        icon: <UsersIcon data-qa-id="allAuthorFiles" />,
    },
    showMyFilesOnly: {
        text: 'Только мои файлы',
        id: 'showMyFilesOnly',
        withStatus: true,
        icon: <UserIcon data-qa-id="showMyFilesOnly" />,
    },
    rename: {
        text: 'Переименовать',
        id: 'rename',
        icon: <RenameIcon data-qa-id="rename" />,
        onClick: toolbarActions.rename,
    },
    addToFavorite: {
        text: 'Добавить в избранные',
        id: 'addToFavorite',
        icon: <FavoriteIcon color={EColor.BLACK} data-qa-id="addToFavorite" />,
    },
    removeFromFavorites: {
        text: 'Убрать из избранных',
        id: 'removeFromFavorites',
        icon: <FavoriteIcon active color={EColor.BLACK} data-qa-id="removeFromFavorites" />,
    },
    copy: {
        text: 'Копировать',
        id: 'copy',
        icon: <CopyIcon data-qa-id="copy" />,
        onClick: toolbarActions.copy,
    },
    viewHistory: {
        text: 'Посмотреть историю',
        id: 'viewHistory',
        icon: <HistoryIcon data-qa-id="viewHistory" />,
        onClick: toolbarActions.viewHistory,
    },
    move: {
        text: 'Переместить в папку',
        id: 'move',
        icon: <MoveIcon data-qa-id="move" />,
        onClick: toolbarActions.move,
    },
    remove: {
        text: 'Удалить',
        id: 'remove',
        icon: <TrashbinIcon data-qa-id="remove" />,
        onClick: toolbarActions.remove,
    },
    download: {
        text: 'Скачать',
        id: 'download',
        icon: <DownloadIcon data-qa-id="download" />,
        onClick: toolbarActions.download,
        divider: true,
    },
    upload: {
        text: 'Загрузить файлы',
        id: 'upload',
        icon: <UploadIcon data-qa-id="upload" width={16} height={16} />,
        onClick: noop,
        mod: 'new',
        hotkey: 'Shift+I',
    },
    uploadFolder: {
        text: 'Загрузить папку',
        id: 'uploadFolder',
        icon: <UploadFolderIcon data-qa-id="uploadFolder" width={16} height={16} />,
        onClick: noop,
        mod: 'new',
        hotkey: 'Shift+U',
    },
};

const currentFolder = (storage): any => (storage ? getStorageCurrentFolder(store.getState(), storage) : app.currentFolder());
const isAuthorized = (): boolean => app.user.isAuthorized();
const filterAllHandler = () => store.dispatch(filesFilterAll());
const filterOneHandler = (author) => store.dispatch(filesFilterOne(author));

export const isItemsEmailUrlOk = (items) => {
    if (!items?.length) {
        return true;
    }

    let length = 2; // 2 array brackets
    items.forEach((item) => {
        const itemLength = encodeURIComponent(item?.id).length + 3; // + 2 commas + 1 comma: "id",
        length += itemLength;
    });

    return length <= MAX_EMAIL_URL_LENGTH && items.length <= 100;
};

const getDownloadItem = (items): ContextMenuItem => {
    let text = '';
    const size = getDownloadItemSize(items);
    const textSize = size ? ` (${size})` : '';

    if (items.length === 1) {
        const ext = getTrimmedText(items[0].ext?.toLowerCase(), 10);
        const extText = ext ? `в .${ext}` : '';
        text = `Скачать ${items[0].isFolder ? 'в .zip' : extText}${textSize}`;
    } else {
        text = `Скачать в .zip${textSize}`;
    }

    if (items.length === 1 && downloadAsJpeg.isAvailable({ ext: items[0].ext, storage: items[0].storage })) {
        return {
            ...contextMenuItems.download,
            id: 'downloadAsJpeg',
            text,
            borderedArrow: true,
            openNestedByArrow: true,
            theme: DropdownTheme.jpeg,
            list: downloadAsJpeg.getDropdownItems({ itemOrId: items[0], gaSuffix: CONTEXT_MENU, ext: items[0].ext }),
        };
    }

    return {
        ...contextMenuItems.download,
        onClick: contextMenuItems.download.onClick,
        text,
    };
};
const getSocialItems = (items: Item[]): ContextMenuItem => {
    return {
        ...contextMenuItems.socialsShare,
        divider: true,
        list: [
            {
                ...contextMenuItems.socialsShareVk,
                onClick: () => publishSocial('vk', items[0]),
            },
            {
                ...contextMenuItems.socialsShareOk,
                onClick: () => publishSocial('ok', items[0]),
            },
            {
                ...contextMenuItems.socialsShareTw,
                onClick: () => publishSocial('tw', items[0]),
            },
            {
                ...contextMenuItems.socialsShareMm,
                onClick: () => publishSocial('mm', items[0]),
            },
        ],
    };
};

const createDefaultMenu = ({ storage, section }: { storage: string; section: string }) => {
    const storageHelper = getStorage(storage);
    const sectionHelper = getStorage(section);
    const state = store.getState();
    const list: ContextMenuItem[] = [];
    const currentView = settingsController.getViewMode();
    const folder = getStorageCurrentFolder(state, storage as EStorageType);
    const sort = getSort(state, folder, storage);
    const { type: sortType, order } = storageHelper.isGallery || sectionHelper.isStart ? { order: null, type: null } : sort;
    const asc = order === ESortOder.asc;
    const availableCreateEditors = getCreateDescriptions(state);
    const isMediaFolder = isMediaFolderAndGalleryEnabled(state, folder);
    const userEmail = UserSelectors.getEmail(state);
    // @ts-ignore
    const authors = getFolderAuthors(state, folder);
    const isWritable = folder && 'weblinkAccessRights' in folder && folder?.weblinkAccessRights === 'rw';
    const storageConfig = getStorageConfig(storage as EStorageType);

    const showDownload = storageHelper.isPublic;
    const showCreate =
        !sectionHelper.isStart && storageHelper.isHome && !isReadOnly(folder) && !storageHelper.isSearch && !storageHelper.isSharedIncoming;
    const showAuthors =
        ((storageHelper.isPublic && isWritable) || storageHelper.isHome) &&
        isAuthorized() &&
        (authors?.length > 1 || (authors[0] && userEmail === authors[0]));
    const showSocials = storageHelper.isPublic && isAuthorized() && !IS_ONPREMISE;
    const showEmail = sendViaMailEnabled && storageHelper.isPublic && isAuthorized();
    const showViewMode = !isMobile;
    const showSort: boolean = storageConfig.sort;
    const isAddToAlbumsAvailable = isAddToAlbumsEnabled(state, []);

    if (storageHelper.isSharedIncoming || (sectionHelper.isStart && storageHelper.isFeed)) {
        return list;
    }

    if (storageHelper.isAlbums && isAddToAlbumsAvailable) {
        list.push(contextMenuItems.addToAlbum);
    }

    if (showDownload) {
        list.push({
            ...getDownloadItem([currentFolder(storage)]),
            divider: showEmail || showSocials,
        });
    }

    if (showEmail) {
        list.push({
            ...contextMenuItems.sendViaMail,
            divider: !showSocials,
        });
    }

    if (showSocials) {
        list.push({
            // @ts-ignore
            ...getSocialItems([folder]),
            divider: true,
        });
    }

    if (showCreate) {
        const createList = [contextMenuItems.createFolder];

        createList.push(
            ...availableCreateEditors.reduce((acc, cur) => {
                if (cur.name === 'docx') {
                    return [...acc, contextMenuItems.createDoc];
                } else if (cur.name === 'xlsx') {
                    return [...acc, contextMenuItems.createCell];
                } else if (cur.name === 'pptx') {
                    return [...acc, contextMenuItems.createPpt];
                }
                return acc;
            }, [] as ContextMenuItem[])
        );
        list.push({
            ...contextMenuItems.create,
            list: createList,
        });
    }

    if (showAuthors) {
        const currentFilter = getCurrentFilter(state);
        // @ts-ignore
        const itemClickHandler = (id): void => {
            if (id === 'showMyFilesOnly') {
                filterOneHandler(userEmail);
            } else if (id === 'allAuthorFiles' && currentFilter !== 'all') {
                filterAllHandler();
            }
        };
        const subItems = [
            {
                ...contextMenuItems.showAllAuthorFiles,
                withStatus: true,
                active: currentFilter === 'all',
                onClick: itemClickHandler,
            },
            {
                ...contextMenuItems.showMyFilesOnly,
                active: !!userEmail && Array.isArray(currentFilter) && currentFilter.includes(userEmail) && currentFilter.length === 1,
                onClick: itemClickHandler,
            },
        ];

        list.push({
            ...contextMenuItems.authors,
            list: subItems,
        });
    }

    if (showViewMode) {
        const viewItem = {
            ...contextMenuItems.view,
            list: [
                {
                    ...contextMenuItems.viewList,
                    active: currentView === EViewMode.list,
                },
                {
                    ...contextMenuItems.viewThumbs,
                    active: currentView === EViewMode.thumbs,
                },
            ],
        };

        if (storageHelper.isGallery || isMediaFolder) {
            viewItem.list.push({
                ...contextMenuItems.viewGallery,
                active: currentView === EViewMode.gallery,
            });
        }

        list.push(viewItem);
    }

    if (showSort) {
        list.push({
            // eslint-disable-next-line max-lines
            ...contextMenuItems.sort,
            list: [
                {
                    ...contextMenuItems.sortName,
                    active: sortType === ESortTypes.name,
                    onClick: () => toolbarActions.sort(`name-${sortType !== ESortTypes.name || !asc ? ESortOder.asc : ESortOder.desc}`),
                    asc,
                },
                {
                    ...contextMenuItems.sortSize,
                    active: sortType === ESortTypes.size,
                    onClick: () => toolbarActions.sort(`size-${sortType !== ESortTypes.size || !asc ? ESortOder.asc : ESortOder.desc}`),
                    asc,
                },
                {
                    ...contextMenuItems.sortDate,
                    active: sortType === ESortTypes.mtime,
                    onClick: () => toolbarActions.sort(`mtime-${sortType !== ESortTypes.mtime || !asc ? ESortOder.asc : ESortOder.desc}`),
                    asc,
                },
            ],
        });
    }

    return list;
};

const createSingleMenu = ({ storage, item }: { storage: EStorageType; item: Item }) => {
    const state = store.getState();
    const isSharedOrMounted = isMountedOrSharedFolder(state, item);
    const isMounted: boolean = isSharedOrMounted.isMounted;
    const isDomainItem: boolean = isDomainFolder(item);
    const storageHelper = getStorage(storage);
    const isOwner = pathOr(true, ['isOwner'], item);
    const isOwnItem = Boolean(item?.home) || (IS_PUBLIC_ALBUM && IS_OWN_PUBLIC);
    const folder = currentFolder(storage);
    const readOnly = isReadOnly(folder);
    const userEmail = UserSelectors.getEmail(state);
    const fileAuthor = path(['author'], item);
    const isWritable = isPublicUploadEnabled(state) || IS_PUBLIC_ALBUM;
    const currentFilter = getCurrentFilter(state);
    const { isAlbums } = storageHelper;
    // @ts-ignore
    const authors = getFolderAuthors(state, folder);
    const storageConfig = getStorageConfig(storage as EStorageType);
    // Элемент в альбоме
    const isAlbumItem = isAlbums && !isAlbum(item);
    const isPublicAlbumEnabled = isCreatePublicAlbumsEnabled(state, [item]);

    const showOpenInNewTab = !storageHelper.isSharedIncoming || isOwner || isMounted;
    const openParentFolder = storageConfig.openParentFolder;
    const showPublish = (isAlbums && isPublicAlbumEnabled) || (!isAlbums && storageConfig.publish);
    const showShare: boolean =
        storageConfig.share &&
        !isDomainItem &&
        item.isFolder &&
        (isOwner || isMounted) &&
        (!(isSharedOrMounted.isMounted || isSharedOrMounted.isShared) || item.id === isSharedOrMounted.folderId);
    const showAuthorFiles =
        (storageHelper.isHome || (storageHelper.isPublic && isWritable)) &&
        isAuthorized() &&
        pathOr(0, ['length'], authors) > 1 &&
        !item.isFolder;
    const showMyFiles = !item.isFolder && isWritable && storageHelper.isPublic && authors?.length === 1;
    const showSaveToCloud = (storageHelper.isPublic || storageHelper.isStock) && isAuthorized() && canCloneWeblink(isAuthorized(), storage);
    const showEmail =
        sendViaMailEnabled &&
        (!item.isFolder || storageHelper.isPublic || storageHelper.isStock) &&
        isAuthorized() &&
        !storageHelper.isQuotaCleaner;
    const showSocials = storageHelper.isPublic && isAuthorized() && !IS_ONPREMISE;
    const showAddToFavorites =
        item.id !== ROOT_FOLDER_ID &&
        !readOnly &&
        !isDomainFolder(folder) &&
        (item.isFolder || !item.isMounted) &&
        storageConfig.favorites &&
        !isAlbum(item);
    const showRename = !isAlbumItem && !readOnly && !isDomainItem && storageConfig.rename;
    const showCopy = storageConfig.copy;
    const showMountFolder = storageHelper.isSharedIncoming && !isMounted;
    const showRemove =
        !readOnly &&
        !isDomainItem &&
        storageConfig.remove &&
        (!storageHelper.isPublic || (isWritable && !item.isFolder && (fileAuthor === userEmail || isOwnItem)));
    const showDownload = isOwner || isMounted;
    const showViewHistory = !item.isFolder && !readOnly && storageConfig.history;
    const showMove = !readOnly && !isDomainItem && storageConfig.move;
    const isAddToAlbumsAvailable = isAddToAlbumsEnabled(state, [item]);

    let list: ContextMenuItem[] = [];

    if (showOpenInNewTab) {
        const path = getPathToNewTab(item, storage, userEmail);

        let onOpenNewTab = () => (isFileForOpenInEditor(item) ? openEditor(item) : window.open(`${window.location.origin}/${path}`));

        if (storageHelper.isQuotaCleaner) {
            onOpenNewTab = () => store.dispatch(openUserQuotaItemView({ id: item.id }));
        }

        list.push({
            ...contextMenuItems.newTab,
            divider:
                !openParentFolder &&
                !storageHelper.isSharedIncoming &&
                !isDomainItem &&
                !storageHelper.isSharedLinks &&
                !storageHelper.isSharedAutodelete &&
                !storageHelper.isStock,
            onClick: onOpenNewTab,
        });
    }

    if (openParentFolder) {
        list.push({
            ...contextMenuItems.parentFolder,
            onClick: () => window.open(getGoToAndScrollUrl(item.parentFolder || item.parent || '', item.id)),
        });
    }

    if (showPublish) {
        list.push({
            ...(item.weblink ? contextMenuItems.publishGetLink : contextMenuItems.publish),
            onClick: () => publishHelper({ item, publishFrom: 'ctx', itemStorage: storage }),
            divider: !showShare && !storageHelper.isSharedIncoming && !showEmail && !isDomainItem,
        });
    }

    if (showShare) {
        list.push({
            ...(isSharedFolder(item) || isMounted ? contextMenuItems.manageAccess : contextMenuItems.share),
            // @ts-ignore
            onClick: toolbarActions.share,
            divider: !storageHelper.isSharedIncoming,
        });
    }

    const downloadAndSaveItems: ContextMenuItem[] = [];
    if (showDownload) {
        downloadAndSaveItems.push({
            ...getDownloadItem([item]),
            divider:
                !isDomainItem &&
                ((item.isFolder && !storageHelper.isPublic && !storageHelper.isSharedIncoming) ||
                    storageHelper.isFavorites ||
                    (storageHelper.isPublic && isOwner && !canCloneWeblink(isAuthorized(), storage))),
        });
    }

    if (showSaveToCloud) {
        downloadAndSaveItems.push({
            ...contextMenuItems.saveToCloud,
            divider: storageHelper.isPublic && canCloneWeblink(isAuthorized(), storage) && !storageHelper.isSharedIncoming,
        });
    }

    const itemsRemove: ContextMenuItem[] = [];
    if (showRemove) {
        itemsRemove.push({
            ...contextMenuItems.remove,
            divider: showAuthorFiles || storageHelper.isPublic,
        });
    }

    const itemsAuthors: ContextMenuItem[] = [];
    if (showAuthorFiles || showMyFiles) {
        const itemClickHandler = (): void => {
            if (currentFilter !== 'all') {
                filterAllHandler();
            } else {
                filterOneHandler(fileAuthor || userEmail);
            }
        };

        itemsAuthors.push({
            ...(currentFilter !== 'all'
                ? contextMenuItems.showAllAuthorFiles
                : (showMyFiles
                ? {
                      ...contextMenuItems.showMyFilesOnly,
                      withStatus: false,
                      onClick: itemClickHandler,
                  }
                : contextMenuItems.showAuthorFiles)),
            onClick: itemClickHandler,
            divider: storageHelper.isPublic,
        });
    }

    if (storageHelper.isPublic) {
        list.push(...downloadAndSaveItems);
        list.push(...itemsRemove);
        list.push(...itemsAuthors);
    }

    if (showEmail) {
        list.push({
            ...contextMenuItems.sendViaMail,
            divider: !showSocials && !showShare && !storageHelper.isAttaches && !isDomainItem,
        });
    }

    if (isAddToAlbumsAvailable) {
        list.push(contextMenuItems.addToAlbum);
    }

    if (showSocials) {
        list.push({
            ...getSocialItems([item]),
            divider: true,
        });
    }

    if (showAddToFavorites) {
        list.push({
            ...(item.isInFavorites ? contextMenuItems.removeFromFavorites : contextMenuItems.addToFavorite),
            onClick: () => {
                if (item.isInFavorites) {
                    store.dispatch(removeFromFavorites({ items: [item as unknown as CloudItem] }));
                    return;
                }

                store.dispatch(addToFavorites({ items: [item as unknown as CloudItem], from: CONTEXT_MENU }));
            },
        });
    }
    if (showRename) {
        list.push(contextMenuItems.rename);
    }

    if (showCopy) {
        list.push(contextMenuItems.copy);
    }

    if (!storageHelper.isPublic && showDownload) {
        list.push(...downloadAndSaveItems);
    }

    if (showViewHistory) {
        list.push({
            ...contextMenuItems.viewHistory,
            divider: !isDomainItem,
        });
    }

    if (showMove) {
        list = [...list, contextMenuItems.move];
    }

    if (showMountFolder) {
        list = [...list, contextMenuItems.mountFolder];
    }

    if (!storageHelper.isPublic) {
        list.push(...itemsRemove);
    }

    if (storageHelper.isHome) {
        list.push(...itemsAuthors);
    }

    if (IS_MY_TEAM) {
        return list.filter((item) => item.id !== 'newTab' && item.id !== 'sendViaMail');
    }

    return list;
};

const createMultiMenu = ({ storage, items }): ContextMenuItem[] => {
    let list: ContextMenuItem[] = [];
    const folder = currentFolder(storage);
    const readOnly: boolean = isReadOnly(folder);
    const isCurrentFolderMounted: boolean = app.isMounted && app.isMounted(folder);
    const mountedItems = items.filter((item) => 'isMounted' in item && item.isMounted && !item.isFolder);
    const isCurrentFolderDomain: boolean = isDomainFolder(folder);
    const onlyFiles: boolean = items.every((item) => !item.isFolder);
    const hasDomainItem: boolean = !onlyFiles && items.some(isDomainFolder);
    const storageHelper = getStorage(storage);
    const state = store.getState();
    const userEmail = UserSelectors.getEmail(state);
    const isWritable = isPublicUploadEnabled(state) || IS_PUBLIC_ALBUM;
    const storageConfig = getStorageConfig(storage as EStorageType);
    const isPublicAlbumEnabled = isCreatePublicAlbumsEnabled(state, items);
    const isAddToAlbumsAvailable = isAddToAlbumsEnabled(state, items);
    const isOwnFiles = items.every((item) => path(['home'], item)) || (IS_PUBLIC_ALBUM && IS_OWN_PUBLIC);

    if (storageHelper.isSharedIncoming && items.length > 1 && items.some((item): boolean => !isMountedFolder(item))) {
        return list;
    }

    const canClone = items.every(() => canCloneWeblink(isAuthorized(), storage));
    const showPublish = storageConfig.publish;
    const showUnpublish = items.some((item) => item.weblink) && storageConfig.publish;
    const showSaveToCloud = (storageHelper.isPublic || storageHelper.isStock) && isAuthorized() && canClone;

    const showEmail =
        (((folder.home || storageHelper.isGallery || storageHelper.isFeed || storageHelper.isDocuments) &&
            !storageHelper.isStock &&
            !(isCurrentFolderDomain && readOnly)) ||
            storageHelper.isSharedLinks ||
            storageHelper.isAttaches) &&
        onlyFiles &&
        sendViaMailEnabled &&
        isItemsEmailUrlOk(items);
    const showFavorites = !readOnly && !isCurrentFolderDomain && !isCurrentFolderMounted && storageConfig.favorites && !mountedItems.length;
    const showCopy = storageConfig.copy;
    const showDownload = (!storageHelper.isAttaches || (storageHelper.isAttaches && items.length <= 100)) && !storageHelper.isQuotaCleaner;
    const showMove = !readOnly && !hasDomainItem && storageConfig.move && !(isCurrentFolderDomain && readOnly);
    const showRemove =
        !readOnly &&
        !hasDomainItem &&
        storageConfig.remove &&
        (!storageHelper.isPublic ||
            (isWritable && onlyFiles && (items.every((item) => path(['author'], item) === userEmail) || isOwnFiles))) &&
        !storageHelper.isSharedLinks &&
        !storageHelper.isSharedAutodelete &&
        !(isCurrentFolderDomain && readOnly) &&
        !(storageHelper.isSharedIncoming && items.length > 1);

    if (showPublish && isPublicAlbumEnabled) {
        list.push(contextMenuItems.publishAlbum);
    }

    if (showUnpublish) {
        list.push({
            ...contextMenuItems.unPublish,
            onClick: () => unPublishHelper({ items }),
            divider: !hasDomainItem && (!onlyFiles || storageHelper.isFavorites || storageHelper.isSearch) && !showEmail,
        });
    }

    const downloadAndSaveItems: ContextMenuItem[] = [];
    if (showDownload) {
        downloadAndSaveItems.push({
            ...getDownloadItem(items),
            divider:
                !hasDomainItem &&
                ((storageHelper.isPublic && !canClone) ||
                    storageHelper.isSearch ||
                    (storageHelper.isHome && !isCurrentFolderDomain) ||
                    storageHelper.isSharedLinks ||
                    storageHelper.isSharedAutodelete ||
                    storageHelper.isFavorites ||
                    storageHelper.isFeed),
        });
    }

    if (showSaveToCloud) {
        downloadAndSaveItems.push({
            ...contextMenuItems.saveToCloud,
            divider: storageHelper.isPublic && canClone,
        });
    }

    if (storageHelper.isPublic) {
        list.push(...downloadAndSaveItems);
    }

    if (showEmail) {
        list.push({
            ...contextMenuItems.sendViaMail,
            divider: !storageHelper.isAttaches && !storageHelper.isPublic && !isCurrentFolderDomain,
        });
    }

    if (isAddToAlbumsAvailable) {
        list.push(contextMenuItems.addToAlbum);
    }

    if (showFavorites) {
        const isAllInFav = items.every((item) => item.isInFavorites);
        list = [
            ...list,
            {
                ...(isAllInFav ? contextMenuItems.removeFromFavorites : contextMenuItems.addToFavorite),
                onClick: () => {
                    if (isAllInFav) {
                        store.dispatch(removeFromFavorites({ items }));
                        return;
                    }

                    store.dispatch(addToFavorites({ items, from: CONTEXT_MENU }));
                },
            },
        ];
    }

    if (showCopy) {
        list.push({
            ...contextMenuItems.copy,
        });
    }

    if (!storageHelper.isPublic) {
        list.push(...downloadAndSaveItems);
    }

    if (showMove) {
        list.push({ ...contextMenuItems.move });
    }

    if (showRemove) {
        list = [...list, contextMenuItems.remove];
    }

    return list.map((item) => ({
        ...item,
        text: `${item.text} (${items.length})`,
    }));
};

export const createFolderMenu = (createFrom) => [
    { ...contextMenuItems.createFolder, onClick: () => toolbarActions.create('folder', createFrom) },
];

export const createDocumentMenu = (createFrom) => {
    const availableCreateEditors = getCreateDescriptions(store.getState());

    const createDocument = (type) => toolbarActions.create(type, createFrom);

    return availableCreateEditors.reduce((acc, cur) => {
        if (cur.name === 'docx') {
            return [
                ...acc,
                {
                    ...contextMenuItems.createDoc,
                    onClick: () => createDocument('docx'),
                },
            ];
        } else if (cur.name === 'xlsx') {
            return [
                ...acc,
                {
                    ...contextMenuItems.createCell,
                    onClick: () => createDocument('xlsx'),
                },
            ];
        } else if (cur.name === 'pptx') {
            return [
                ...acc,
                {
                    ...contextMenuItems.createPpt,
                    onClick: () => createDocument('pptx'),
                },
            ];
        }

        return acc;
    }, [] as ContextMenuItem[]);
};

const createUploadMenu = (isUpload: boolean, uploadHandler) => {
    const res = isUpload ? [{ ...contextMenuItems.upload, onClick: uploadHandler, disablePreventDefault: true, divider: true }] : [];

    const state = store.getState();
    if (isUpload && isUploadFolderAllowed(state)) {
        res[0].divider = false;
        res.push({ ...contextMenuItems.uploadFolder, onClick: uploadHandler, disablePreventDefault: true, divider: true });
    }

    return res;
};

export const createCreateNewMenu = ({ createFrom = '', isUpload = false, uploadHandler = noopVoid } = {}) => {
    return [...createUploadMenu(isUpload, uploadHandler), ...createFolderMenu(createFrom), ...createDocumentMenu(createFrom)];
};

export const createContextMenu = ({
    storage,
    section,
    items,
    renderDefault,
}: {
    storage: string;
    section?: string;
    items?: Item[];
    renderDefault?: boolean;
}): ContextMenuItem[] => {
    if (renderDefault || !items || !items.length) {
        return createDefaultMenu({ storage, section: section || '' });
    }

    if (items && items.length === 1) {
        return createSingleMenu({ storage: storage as EStorageType, item: items[0] });
    }
    return createMultiMenu({ storage, items });
};
